export default __webpack_public_path__ + "static/media/BOB_0139.d894354c.JPG";